import { render, staticRenderFns } from "./WebLinksEditor.vue?vue&type=template&id=479fedc9&scoped=true"
import script from "./WebLinksEditor.vue?vue&type=script&lang=js"
export * from "./WebLinksEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479fedc9",
  null
  
)

export default component.exports